/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Showcase_Latestactivity1Inputs */

const id_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivitas terbaru`)
};

const ms_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiviti terkini`)
};

const da_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seneste aktivitet`)
};

const de_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Aktivität`)
};

const en_us2_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest activity`)
};

const es_es2_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última actividad`)
};

const es_mx2_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última actividad`)
};

const fil_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinakabagong aktibidad`)
};

const fr_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernière activité`)
};

const it_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultima attività`)
};

const hu_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legutóbbi tevékenység`)
};

const nl_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatste activiteit`)
};

const no_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siste aktivitet`)
};

const pl_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najnowsza aktywność`)
};

const pt_br2_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última atividade`)
};

const pt_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividade mais recente`)
};

const ro_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultima activitate`)
};

const fi_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeisin toiminta`)
};

const sv_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senaste aktivitet`)
};

const vi_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoạt động mới nhất`)
};

const tr_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son aktivite`)
};

const cs_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejnovější aktivita`)
};

const bg_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последна активност`)
};

const ru_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последняя активность`)
};

const uk_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Остання активність`)
};

const ar_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آخر نشاط`)
};

const hi_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नवीनतम गतिविधि`)
};

const th_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กิจกรรมล่าสุด`)
};

const ja_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新アクティビティ`)
};

const zh_cn2_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近动态`)
};

const zh_hant1_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近動態`)
};

const ko_profile_showcase_latestactivity1 = /** @type {(inputs: Profile_Showcase_Latestactivity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최근 활동`)
};

/**
* | output |
* | --- |
* | "Latest activity" |
*
* @param {Profile_Showcase_Latestactivity1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_showcase_latestactivity1 = /** @type {((inputs?: Profile_Showcase_Latestactivity1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Showcase_Latestactivity1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_showcase_latestactivity1(inputs)
	if (locale === "ms") return ms_profile_showcase_latestactivity1(inputs)
	if (locale === "da") return da_profile_showcase_latestactivity1(inputs)
	if (locale === "de") return de_profile_showcase_latestactivity1(inputs)
	if (locale === "en-US") return en_us2_profile_showcase_latestactivity1(inputs)
	if (locale === "es-ES") return es_es2_profile_showcase_latestactivity1(inputs)
	if (locale === "es-MX") return es_mx2_profile_showcase_latestactivity1(inputs)
	if (locale === "fil") return fil_profile_showcase_latestactivity1(inputs)
	if (locale === "fr") return fr_profile_showcase_latestactivity1(inputs)
	if (locale === "it") return it_profile_showcase_latestactivity1(inputs)
	if (locale === "hu") return hu_profile_showcase_latestactivity1(inputs)
	if (locale === "nl") return nl_profile_showcase_latestactivity1(inputs)
	if (locale === "no") return no_profile_showcase_latestactivity1(inputs)
	if (locale === "pl") return pl_profile_showcase_latestactivity1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_showcase_latestactivity1(inputs)
	if (locale === "pt") return pt_profile_showcase_latestactivity1(inputs)
	if (locale === "ro") return ro_profile_showcase_latestactivity1(inputs)
	if (locale === "fi") return fi_profile_showcase_latestactivity1(inputs)
	if (locale === "sv") return sv_profile_showcase_latestactivity1(inputs)
	if (locale === "vi") return vi_profile_showcase_latestactivity1(inputs)
	if (locale === "tr") return tr_profile_showcase_latestactivity1(inputs)
	if (locale === "cs") return cs_profile_showcase_latestactivity1(inputs)
	if (locale === "bg") return bg_profile_showcase_latestactivity1(inputs)
	if (locale === "ru") return ru_profile_showcase_latestactivity1(inputs)
	if (locale === "uk") return uk_profile_showcase_latestactivity1(inputs)
	if (locale === "ar") return ar_profile_showcase_latestactivity1(inputs)
	if (locale === "hi") return hi_profile_showcase_latestactivity1(inputs)
	if (locale === "th") return th_profile_showcase_latestactivity1(inputs)
	if (locale === "ja") return ja_profile_showcase_latestactivity1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_showcase_latestactivity1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_showcase_latestactivity1(inputs)
	return ko_profile_showcase_latestactivity1(inputs)
});
export { profile_showcase_latestactivity1 as "profile.showcase.latestActivity" }